import React from 'react';
import { Overlay } from '~/ui/overlay/Overlay';
import { Background } from './Background';
import { PromptProfile } from './PromptProfile';
import { OnboardingProvider } from './Store';

export const Form = () => {
  return (
    <OnboardingProvider>
      <Background />
      <Overlay open allowScroll>
        <PromptProfile />
      </Overlay>
    </OnboardingProvider>
  );
};
